__turbopack_context__.v({
  "className": "playfair_display_3271df8a-module__mJX0KW__className",
});
